import { render } from "./PayerInformation.vue?vue&type=template&id=7f484c80"
import script from "./PayerInformation.ts?vue&type=script&lang=js&external"
export * from "./PayerInformation.ts?vue&type=script&lang=js&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__